import { appWithTranslation } from 'next-i18next';
import Script from 'next/script';
import 'swiper/css';
import '../index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/datepicker.scss';
import nextI18nConfig from '../next-i18next.config';

function MyApp({ Component, pageProps }) {
  const showMarkerIo = pageProps?.componentProps?.showMarkerIo;
  const rekaiId = pageProps?.componentProps?.siteSetting?.rekaiId;

  return (
    <>
      {rekaiId && (
        <Script
          id="rekai-init"
          src={`https://static.rekai.se/${rekaiId}.js`}
          strategy="afterInteractive"
        />
      )}
      {showMarkerIo && (
        <>
          <Script
            id="marker-script"
            dangerouslySetInnerHTML={{
              __html: `
                window.markerConfig = {
                  project: '680f4bfd21ee5e6541aefa2b',
                  source: 'snippet'
                };

                !function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","clearReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);
            `,
            }}
          />
        </>
      )}
      <Component {...pageProps} />
    </>
  );
}

export default appWithTranslation(MyApp);
